import React, { useCallback, useEffect, useState } from 'react';
import { Spinner } from '@primer/react';

import classNames from 'classnames';

// TODO - Hardcoded z-index in class name may cause issues
// Consider updating to provide z-index via className prop or a separate property
export const LoadingSpinner = ({
  animationKey,
  className = '',
  hidden = false,
  useOverlay = false,
  loadingText = null,
  overlayStyle = {},
  ...rest
}) => {
  const [isDisplayed, setDisplayed] = useState(!hidden);
  const [animationState, setAnimation] = useState(null);

  useEffect(() => {
    if (!hidden) {
      setDisplayed(true);
      setAnimation('fade-in');
    } else {
      setAnimation('fade-out')
    }
  }, [hidden])

  const onAnimationEnd = useCallback(() => {
    if (animationState === 'fade-out') {
      setDisplayed(false);
    }
    setAnimation(null);
  }, [animationState])

  return (
    <div
      key={animationKey}
      className={classNames(
        className,
        'flex items-center justify-center',
        { 'absolute h-full w-full z-40': useOverlay },
        { [`z-40 animate-${animationState}`]: animationState },
      )}
      onAnimationEnd={onAnimationEnd}
    >
      <div
        className={classNames(
          { 'absolute z-40': useOverlay },
        )}
      >
        <Spinner {...rest} sx={{ margin: '0 auto' }} />
        <span>{loadingText}</span> 
      </div>
      {
        (isDisplayed && useOverlay) ? (
          <div
            role="presentation"
            className="absolute top-0 left-0 h-full w-full bg-border-light opacity-50 z-30"
            style={overlayStyle}
          />
        ) : null
      }
    </div>
  )
}

export default LoadingSpinner;
